import { OptionList } from "../../assets/helpers/helpers";

export function getValueByKey<T extends Record<string, string | number>>(
    enumObj: T,
    key: number
): T[keyof T] | undefined {
    return enumObj[key as keyof T];
}

export const getEnumOptionList = <T extends Record<string, string | number>>(
    enumObj: T
): OptionList =>
    Object.values(enumObj)
        .filter((value): value is number => typeof value === "number")
        .map((value) => ({
            id: value,
            name: enumObj[value] as string,
        }));
